/* eslint-disable camelcase */
/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { createAsyncThunk } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';
import { toast } from 'react-toastify';

import blankDesignTheme from '../components/customise/reducers/default-styles';
import errorHandler from './errorHandlerUtility';
import win from './win';

export const roles = win.ROLES;
export const perms = win.PERMS;

export const urlTestPattern =
  /^[a-z](?:[-a-z0-9\+\.])*:(?:\/\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD])*@)?(?:\[(?:(?:(?:[0-9a-f]{1,4}:){6}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|::(?:[0-9a-f]{1,4}:){5}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:[0-9a-f]{1,4}:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|v[0-9a-f]+[-a-z0-9\._~!\$&'\(\)\*\+,=:]+)\]|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3}|(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD])*)(?::[0-9]*)?(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))*)*|\/(?:(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))*)*)?|(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))*)*|(?!(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD])))(?:\?(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:@\/\?\xA0-\uD7FF\uE000-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDC00-\uDFFD])*)?(?:\#(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,=:@\/\?\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD])*)?$/i;
export const emailTestPattern =
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; // Multi-lingual
export const emailTestPatterUnicode =
  /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/i;
export const mobileModelsRegex =
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
export const mobileRegex =
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;


const resolveMultipleDecimals = (str = '') => {
  const parts = str.toString().trim().split('.');
  if (parts.length <= 1) return str;

  const integerPart = parts[0];
  const decimalPart = parts.slice(1).join('');
  return `${integerPart}.${decimalPart}`;
};

export const restrictNonNumericCharacters = (e) => {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

  if (e.target instanceof HTMLInputElement && e.target.type === 'number') {
    const key = e.key;

    // Allow control/meta shortcuts (e.g. Ctrl+C, Ctrl+V)
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    // Allow navigation keys
    if (allowedKeys.includes(key)) return;

    // Allow digits
    if (/^\d$/.test(key)) return;

    // Allow one decimal point if not already present
    if (key === '.' && !e.target.value.includes('.')) return;

    // Block everything else
    e.preventDefault();
  }
};

export const formatNumberInputValue = (e, changeHandler) => {
  const isSafariBrowser = browserIsSafari();

  // Only apply workaround on Safari and number inputs.
  if (e.target.type !== 'number' || !isSafariBrowser) return;

  const pastedValue = resolveMultipleDecimals(e?.clipboardData?.getData?.('text') || '');
  const currentValue = e.target.value;

  // Prevent default paste handling.
  e.preventDefault();

  // Temporarily convert to text input to access selectionStart/End.
  const input = e.target;
  input.type = 'text';

  const currentValueHasDecimalPoint = currentValue.includes('.');
  const pastedValueHasDecimalPoint = pastedValue.includes('.');
  const start = input.selectionStart ?? currentValue.length;
  const end = input.selectionEnd ?? currentValue.length;

  const selectionHasDecimal = currentValue.slice(start, end).includes('.');
  const decimalIsDropped = currentValueHasDecimalPoint && !selectionHasDecimal && pastedValueHasDecimalPoint;
  const cursorOffset = decimalIsDropped ? 1 : 0;

  const newValue = currentValue.slice(0, start) + pastedValue + currentValue.slice(end);
  
  // Set the new value if it's numeric, or fallback.
  input.value = !isNaN(Number(pastedValue)) ? resolveMultipleDecimals(newValue) : currentValue;

  const newCursorPosition = start + pastedValue.length - cursorOffset;
  input.setSelectionRange(newCursorPosition, newCursorPosition);

  // Revert input type back to number.
  input.type = 'number';

  // Manually fire change handler to update state.
  changeHandler(e);
};

const browserIsSafari = () => {
  return /^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent);
};

export function getLoadingMessage() {
  const messages = [
    'Leave a suggestion or give us feedback with the “suggestions” button at the top-right corner of this page.',
    'Make use of the right form field for each question so you don’t confuse your users.',
    'Enable save and continue later to let your respondents save their form progress.',
    'Skip/hide entire form pages with the improved conditional logic',
    'Receive submitted responses in your inbox by enabling email notifications.',
    'Add an intro page to communicate information/instructions before your form is filled.',
    'Create better surveys with the various rating fields.',
    'Collect repeating data by adding a Table field to your forms.',
    'The title of your form should convey the purpose of the form properly.',
    'Send a custom email to your respondents after a form submission.',
    'There are over 100 fonts to choose from, so express yourself with them.',
    'Refine the responses you receive when you set validation rules.',
    'You can change your default storage option from the Settings page.',
    'Use Ctrl + P to print a form or save as PDF when you view the form.',
    'Use the smiley rating field to add a fun side to your feedback forms.',
    'Style the buttons in your form from the Buttons section of the customise page.',
    'Make your forms more beautiful by adding a background image.',
    'Break long forms into multiple pages so you don’t give your users ‘TMI’ at once.',
    'Leave the form title blank to create a form without a title.',
    'Allow respondents print a copy of their response by enabling the print response button.',
    'Remove the underline below the form title from the customise page.',
    'Enable location to receive location data with each form submission.',
    'Close a form by setting the submission deadline to a past date.',
    'View submitted responses individually on the Responses page.',
    'You can change the default form width from the customise page.',
    'Gain insights from data received on the Analytics page.',
    'Add a custom ‘Thank you’ message after a form submission.',
    'Show questions only when they are required by adding form rules.',
    'Click the ‘Save as New’ button in the builder to duplicate a form.',
    'Use the Enter key to save a form field when building your forms.',
    'By default, your respondents can now submit a form offline on supported browsers.',
    'You can change the font size of texts in your form from the customise page.',
    'Form responses can be downloaded as PDF, DOCX or CSV files from the responses page.',
    'Collect payments with forms. Add the PayPal, Stripe or Flutterwave payment fields to your forms.',
  ];
  return messages[Math.floor(Math.random() * messages.length)];
}

export const getCountriesList = () => {
  return [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'Andorra', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia, Plurinational State of', code: 'BO' },
    { name: 'Bonaire, Sint Eustatius and Saba', code: 'BQ' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, the Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: "Côte d'Ivoire", code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Curaçao', code: 'CW' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and McDonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: "Korea, Democratic People's Republic of", code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: "Lao People's Democratic Republic", code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, the Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montenegro', code: 'ME' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestine, State of', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Réunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'Rwanda', code: 'RW' },
    { name: 'Saint Barthélemy', code: 'BL' },
    { name: 'Saint Helena, Ascension and Tristan da Cunha', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Martin (French part)', code: 'MF' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia', code: 'RS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Sint Maarten (Dutch part)', code: 'SX' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'South Sudan', code: 'SS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela, Bolivarian Republic of', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' },
  ];
};

export const getEnvironment = () => {
  if (process.env.NODE_ENV === 'production') {
    if (window.location.host !== 'www.formpl.us') {
      // This is staging
      return 'staging';
    }

    return 'production';
  }

  return 'development';
};

export function list2Dict(list) {
  return list.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
}

export function isMobile() {
  let check = false;
  (function mobileCheck(a) {
    if (mobileRegex.test(a) || mobileModelsRegex.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

export function rolesList() {
  return [
    { key: 'admin', text: 'Admin', value: 'admin' },
    { key: 'approver', text: 'Approver', value: 'approver' },
    { key: 'creator', text: 'Creator', value: 'creator' },
    { key: 'viewer', text: 'Editor', value: 'viewer' },
    { key: 'editor', text: 'Viewer', value: 'editor' },
  ];
}

export function isOwner(team = {}) {
  if (!team.owner && win.ACTIVE_USER_ID === '0') {
    return true;
  }
  if (!team.owner) {
    return `${win.USER_ID}` === `${win.ACTIVE_USER_ID}`;
  }
  return `${win.USER_ID}` === `${team.owner}`;
}

export function hasPerm(perm, team = {}) {
  // Checks if logged in user has perm for team.
  let member = win.ACTIVE_MEMBER || {};
  if (`${win.USER_ID}` === `${team.owner}`) return true; // Owner has all.
  if (!member.roles) {
    // Not owner and not switched
    member = team.member || {}; // get member from team when not switched
    if (!member.roles) return false;
  }
  if (`${member.team}` !== `${team.id}`) return false; // Not in team

  let has = false;
  for (const idx in member.roles) {
    const role = member.roles[idx];
    
    if (!roles[role]) {
      has = false;
      break;
    }

    if (BigInt(roles[role]) % BigInt(perm) == 0) {
      has = true;
      break;
    }
  }
  return has;
}

export function hasTeam() {
  // Checks if logged in user has access to teams.
  const { PLAN } = win;
  return PLAN.allowed_features.TEAMS;
}

export function planName() {
  // Returns plan name.
  const { PLAN } = win;
  const name = PLAN.name.replace('_yearly', '');
  return capitalize(name.replace('_subscription', ''));
}

export function capitalize(s) {
  if (!s) return '';
  if (s === 'viewer') return 'Editor';
  if (s === 'editor') return 'Viewer';
  return s.charAt(0).toLocaleUpperCase() + s.substring(1);
}

export const isPermittedTo = (permission) => {
  // In a team instance, checks if user is the team owner or has given permission
  const { ACTIVE_TEAM, PERMS } = win;
  if (isOwner()) return true;
  if (hasPerm(PERMS[permission], ACTIVE_TEAM)) return true;
  return false;
}

export function enabledNotes() {
  if (
    win.PLAN.is_premium ||
    win.PLAN.is_unlimited ||
    win.PLAN.is_starter ||
    win.PLAN.is_professional ||
    win.PLAN.is_platinum ||
    win.PLAN.is_enterprise
  ) {
    return true;
  }
  return false;
}

export function capitalizr(a) {
  return a.map((s) => capitalize(s));
}

export const tryParseJSONObject = (jsonString) => {
  try {
    const o = JSON.parse(jsonString);

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (e) {
    return false;
  }
};

export const validateFilename = (name) => {
  const invalidChars = '/\\:;*?"<>|\'';
  const newName = name.substr(0, 250);
  let result = '';

  for (var n = 0; n < newName.length; n++) {
    if (invalidChars.indexOf(newName[n]) == -1) {
      result += newName[n]
    }
  }
  
  return result;
};

export const checkTrackedPremiumFieldsErrorForForm = (formId) => {
  const premiumFieldsErrorFormStorageKey = '_fpls_premium_field_error_form_';
  if (premiumFieldsErrorFormStorageKey in localStorage) {
    const errorFormId = localStorage.getItem(premiumFieldsErrorFormStorageKey);
    if (formId === errorFormId) return true;
  }
  return false;
};

export function sendTimeToMixpanel(initialTime, page) {
  const timeSpent = new Date().valueOf() - initialTime.valueOf();
  window.mixpanel.track('Time Spent', {
    Page: page,
    'Time spent': getReadableTime(timeSpent / 1000),
    'Time in seconds': parseInt(timeSpent / 1000, 10),
  });
}

function getReadableTime(secs) {
  const sec_num = parseInt(secs, 10);
  const hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor(sec_num / 60) % 60;
  const seconds = sec_num % 60;
  let result = '';

  if (seconds > 0) {
    result += seconds + (seconds > 1 ? ' seconds' : ' second');
  }
  if (minutes > 0) {
    result = minutes + (minutes > 1 ? ' minutes ' : ' minute ') + result;
  }
  if (hours > 0) {
    result = hours + (hours > 1 ? ' hours ' : ' hour ') + result;
  }

  return result.trim();
}

const nestedFieldTransform = (data, fieldTitle) => {
  const transformedData = {};
  const fieldData = data.form[fieldTitle];
  for (const attr in fieldData) {
    if (fieldData[attr] !== null) {
      transformedData[attr] = fieldData[attr];
    }
  }
  return transformedData;
};

export function insert(str, index, value) {
  return str.substr(0, index) + value + str.substr(index);
}

export function replaceAt(str, index, value) {
  const a = str.split('');
  if (a[index] === 'n') {
    a[index] = value;
  }
  return a.join('');
}

const transformRequest = (data) => {
  const payload = {};
  payload.formjsonEdited = data.formjsonEdited;
  const nestedFields = { options: true, design: true };
  for (const field in nestedFields) {
    payload[field] = nestedFieldTransform(data, field);
  }
  for (const p in data.form) {
    if (p in nestedFields) continue;
    if (data.form[p] !== null) {
      payload[p] = data.form[p];
    }
  }
  if (payload.form_external_css) {
    const newExternalCss = insert(payload.form_external_css, 0, 'n');
    payload.form_external_css = newExternalCss;
  }
  // value, subtext
  if (payload.definition) {
    for (let i = 0; i < payload.definition.pages.length; i += 1) {
      if (!payload.definition.pages[i].internal_id) {
        delete payload.definition.pages[i].internal_id;
      }
      for (let j = 0; j < payload.definition.pages[i].controls.length; j += 1) {
        // value
        const ctrl = cloneDeep(payload.definition.pages[i].controls[j]);
        if (!ctrl.value) {
          delete ctrl.value;
          // payload.definition.pages[i].controls[j] = ctrl
        }
        // props
        const props = Object.keys(ctrl.props);
        let q;
        for (q = 0; q < props.length; q += 1) {
          if (ctrl.props[props[q]] == null) {
            delete ctrl.props[props[q]];
          }
          if (props[q] === 'other') {
            const otherEnabled = ctrl.props.other.enabled;
            const otherLabeled = ctrl.props.other.label;
            ctrl.props.other.enabled = otherEnabled || false;
            ctrl.props.other.label = otherLabeled || 'Others...';
          }
          if (props[q] === 'rename') {
            const renameEnabled = ctrl.props.rename.enabled;
            const renameInternalID = ctrl.props.rename.internal_id;
            ctrl.props.rename.enabled = renameEnabled || false;
            ctrl.props.rename.internal_id = renameInternalID || '';
          }
        }
        if (ctrl.type === 'table_field') {
          const tableProps = ctrl.table_props; // a list of dictionary props
          for (q = 0; q < tableProps.length; q += 1) {
            const curProps = tableProps[q]; // current props, an object
            const allProps = Object.keys(curProps);
            for (let r = 0; r < allProps.length; r += 1) {
              const attr = allProps[r];
              if (curProps[attr] == null) {
                delete curProps[attr];
              }
            }
          }
        } else if (ctrl.hasOwnProperty('table_props')) {
          // if not a table_field remove the table_properties `table_props`
          delete ctrl.table_props;
        }

        if (ctrl.type === 'inventory_field') {
          const props = cloneDeep(ctrl.props);
          const products = props.inventory_products.map((product) => ({
            ...product,
            payment_currency: product.payment_currency || props.currency,
            inventory_id: Number(ctrl.internal_id),
          }));
          props.inventory_products = products;
          ctrl.props = props;
        }
        payload.definition.pages[i].controls[j] = ctrl;
      }
    }

    // removing null rule properties
    if (payload.definition.rules) {
      const len = payload.definition.rules.length;
      for (let iota = 0; iota < len; iota += 1) {
        const rule = payload.definition.rules[iota];
        for (const prp in rule) {
          if (!rule[prp] && rule.hasOwnProperty(prp)) {
            delete rule[prp];
          }
        }
        if (!rule.actions) {
          rule.actions = [];
        }
        if (!rule.triggers) {
          rule.triggers = [];
        }
        rule.triggers.forEach((t) => {
          if (t.param === null) {
            delete t.param;
          }
          if (t.label === null) {
            delete t.label;
          }
        });
      }
    }
  }
  return payload;
};

export function apiCommon(data) {
  return transformRequest(data);
}

function handleErrors(response) {
  try {
    if (!response.ok) {
      // TODO: Log errors to server
      return response
        .json()
        .then((json) => {
          console.error(`${response.statusText}: ${json.message}`);
          return {
            error: `${json.message}`,
            status: `${response.status}`,
            statusText: `${response.statusText}`,
          };
        })
        .catch(() => {
          console.error(`${response.statusText}: An unknown error has occured.`);
          return { error: 'An unknown error has occured.', status: response.status };
        });
    }
    return response.json();
  } catch (e) {
    console.group('An unknown error has occured.');
    console.error('Error Handler:', response.statusText);
    console.error('Error Handler:', e.message);
    console.groupEnd();
    return { error: 'An unknown error has occured.' };
  }
}

export function fplsFetch({ url = '', data = {}, method = 'GET', contentType, form, removeToken = false } = {}) {
  const headers = {};

  if (contentType) {
    headers['Content-Type'] = contentType;
  } else if (method !== 'GET' && method !== 'DELETE') {
    headers['Content-Type'] = 'application/json';
  }

  if (!removeToken) {
    headers['X-FORMPL-AUTH'] = win.TOKEN;
  }

  const config = {
    method,
    headers,
    mode: 'cors',
    cache: 'no-cache',
    redirect: 'follow',
  };

  if (method !== 'GET' && method !== 'DELETE') {
    config.body = form ? data : JSON.stringify(data);
  }

  return fetch(url, config).then((response) => handleErrors(response))
}

export function fplsResponsesFetch({ url = '', data = {}, method = 'GET' } = {}) {
  const config = {
    method,
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/html',
      'X-FORMPL-AUTH': win.TOKEN,
    },
    redirect: 'follow',
  };
  if (method !== 'GET' && method !== 'DELETE') {
    config.body = JSON.stringify(data);
  }
  return fetch(url, config).then((response) => handleErrors(response));
}

export function fetchIPLocationData(url = '') {
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: {},
  };
  return fetch(url, config).then((response) => handleErrors(response));
}

export const logErrorToCloudReporting = (exception) => {
  errorHandler.report(exception);
}

export function getVersionRecords(versions, majorVersion) {
  const allRecords = {};
  if (majorVersion !== -1) {
    for (let i = 0; i < versions.length; i++) {
      if (versions[i].idx === majorVersion) {
        return [versions[i].records ? versions[i].records : [], {}];
      }
    }
    return [[], {}];
  }

  versions.forEach((versionRecords) => {
    const { records } = versionRecords;
    if (records) {
      records.forEach((record) => {
        if (record.internal_id in allRecords) {
          const currentRec = allRecords[record.internal_id];
          if (!record.has_option && record.type === 'table_field') {
            const fields = record.fields || [];
            fields.forEach((field, idx) => {
              const currentField = currentRec.fields[idx];
              if (currentField && currentField.index === field.index && currentField.type === field.type) {
                currentField.response_count += field.response_count;
              } else {
                currentRec.fields.push(field);
              }
            });
          }

          if (record.has_option) {
            for (const option in record.options) {
              if (option in currentRec.options) {
                if (record.type === 'matrix_rating') {
                  const opts = record.options[option];
                  for (const o in opts) {
                    if (o in currentRec.options[option]) {
                      currentRec.options[option][o] += record.options[option][o];
                    } else {
                      currentRec.options[option][o] = record.options[option][o];
                    }
                  }
                } else {
                  currentRec.options[option] += record.options[option];
                }
              } else {
                currentRec.options[option] = record.options[option];
              }
            }
          }
          currentRec.response_count += record.response_count;
        } else {
          allRecords[record.internal_id] = JSON.parse(JSON.stringify(record));
        }
      });
    }
  });
  return [Object.values(allRecords), allRecords];
}

export function getAvailableFields(recordsObj, fields) {
  let fieldsLen = fields.length;
  while (fieldsLen--) {
    const field = fields[fieldsLen];
    if (!(field.internal_id in recordsObj)) {
      fields.splice(fieldsLen, 1);
    }
  }
  return fields;
}

export function hasDuplicates(array) {
  return new Set(array).size !== array.length;
}

export function preloadComponent(component) {
  component.preload && component.preload();
}

export function shortenDate(isoString) {
  let convertedDate = new Date(isoString);
  // convert to locale date based on computer
  convertedDate = convertedDate.toLocaleString();
  const d = new Date(convertedDate);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();
  const time = d.toLocaleTimeString();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return `${[year, month, day].join('-')} ${time}`;
}

export function hasTableOrMatrix(definition) {
  return definition.pages.some((page) => {
    return page.controls.some((control) => {
      return control.type === 'matrix_rating' || control.type === 'table_field';
    });
  });
}

export const applyTheme = (theme, formObj) => {
  if (!theme) return;
  const themeDesign = cloneDeep(theme.design ?? theme);

  const excludedDesignProperties = ['theme', 'custom_form_width'];
  if (theme.design) excludedDesignProperties.forEach((prop) => delete themeDesign[prop]);

  Object.assign(formObj, theme.form_model);
  Object.assign(formObj.design, themeDesign);
};

export function resetNewOptions(formObj) {
  const theme = blankDesignTheme;
  applyTheme(theme, formObj);
  formObj.design.custom_form_width = hasTableOrMatrix(formObj.definition) ? 80 : 55;
}

export function readableDate(isoString) {
  const convertedDate = new Date(`${isoString}Z`).toString();
  const finalDateArray = convertedDate.split(' ');
  const finalDate = finalDateArray.slice(0, 4);
  const day = `${finalDate[0]},`;
  const time = `${finalDateArray[4]}.`;
  finalDate[0] = day;
  finalDate.unshift(time);
  return finalDate.join(' ');
}

export function getNumbers(num) {
  const arr = [];
  for (let i = 1; i <= num; i += 1) {
    arr.push(i);
  }
  return arr;
}

// export function htmlToPlainText(response) {
//   if (typeof response !== 'string') return response;
//   response = response.replace(/<br>/gi, '\n');
//   response = response.replace(/<p.*>/gi, '\n');
//   response = response.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, ' $2 (File Link - $1) ');
//   response = response.replace(/<(?:.|\s)*?>/g, '');
//   return response;
// }

export function htmlToPlainText(response) {
  if (typeof response !== 'string') return response;
  response = response.replace(/<br\s*\/?>/gi, '\n');                // handle <br> and <br/>
  response = response.replace(/<p[^>]*>/gi, '\n');                  // match <p ...> only
  response = response.replace(/<\/p>/gi, '\n');                     // handle closing </p>
  response = response.replace(/<a[^>]*href="(.*?)".*?>(.*?)<\/a>/gi, ' $2 (File Link - $1) ');
  response = response.replace(/<(?:.|\s)*?>/g, '');                 // strip remaining tags
  return response.trim();
}

export function cleanFormInputFromXSS(props) {
  if (props.label) {
    props.label = htmlToPlainText(props.label);
  }
  if (props.subtext) {
    props.subtext = htmlToPlainText(props.subtext);
  }
  if (props.placeholder) {
    props.placeholder = htmlToPlainText(props.placeholder);
  }
}

export function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export function readCookie(cookiename) {
  const name = `${cookiename}=`;
  const decodedCookie = decodeURIComponent(window.document.cookie);
  const cookies = decodedCookie.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return '';
}

export function generateFileInfo(blob_name, file) {
  const { size } = file;
  const mime_type = file.type.toLowerCase();
  const filename = file.name;

  return {
    size,
    mime_type,
    filename,
    blob_name,
  };
}

export function resolveVideoEmbedUrl(url) {
  const defaultUrl = 'https://www.youtube.com/watch?v=Vlva1_4_mhU';
  const replacementUrl = 'https://www.youtube.com/watch?v=sYovUsfOtJs';

  const cleanedUrl = url ? url.trim() : '';
  if (!cleanedUrl) return '';

  return cleanedUrl.toLowerCase() === defaultUrl.toLowerCase() ? replacementUrl : cleanedUrl;
}

export function loadIframeUrl(url) {
  let embedUrl = '';

  let videoId;
  if (url.includes('youtube.com/watch')) {
    // Video URL format = https://www.youtube.com/watch?v=yfFkY7VWdp0
    // Embed URL format = https://www.youtube.com/embed/6T4C25DBnEY
    videoId = url.substr(url.indexOf('=') + 1);
    embedUrl = `https://www.youtube.com/embed/${videoId}`;
  } else if (url.includes('vimeo.com/')) {
    // Video URL Format = https://vimeo.com/180267405
    // Embed URL Format = https://player.vimeo.com/video/180267405
    videoId = url.substr(url.lastIndexOf('/') + 1);
    embedUrl = `https://player.vimeo.com/video/${videoId}`;
  } else if (url.includes('www.cincopa.com')) {
    // TODO: Hotfix warning here. This needs to be properly validated to handle
    // cases of this string being abused/appended to other URLs
    embedUrl = url;
  }
  return embedUrl;
}

// return $sce.trustAsResourceUrl(embedUrl)
export function setGradient(colorStart, colorEnd, type, shape, direction) {
  let style = `${type}-gradient(`;

  if (type === 'linear') {
    style += direction;
  } else {
    style += shape;
  }

  style += `, #${colorStart}, #${colorEnd})`;
  return style;
}

export const formPageBackgroundStyles = (formDesign) => {
  const {
    design: {
      page_background_type,
      page_gradient_start_color: colorStart,
      page_gradient_end_color: colorEnd,
      page_gradient_type: gradientType,
      page_gradient_shape: shape,
      page_gradient_direction: direction,
    },
    old: {
      form_background_image,
      page_background,
      background_image_size,
      background_image_fixed,
      background_image_repeat,
    },
  } = formDesign;

  switch (page_background_type) {
    case 'pattern':
      return {
        backgroundBlendMode: '',
        backgroundRepeat: 'repeat',
        backgroundImage: form_background_image ? `url('${form_background_image}')` : '',
      };

    case 'fill':
      return {
        backgroundColor: page_background ? `#${page_background}` : '',
        backgroundBlendMode: 'overlay',
      };
    case 'image':
      return {
        backgroundImage: form_background_image ? `url('${form_background_image}')` : '',
        backgroundSize: background_image_size && background_image_size,
        backgroundAttachment: background_image_fixed ? 'fixed' : 'scroll',
        backgroundRepeat: background_image_repeat ? 'repeat' : 'no-repeat',
      };
    case 'gradient':
      return {
        backgroundBlendMode: 'overlay',
        backgroundImage: setGradient(colorStart, colorEnd, gradientType, shape, direction),
      };
    default:
      return null;
  }
};

export const formHexToRgbA = (hex, transparency) => {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  const opacity = transparency ? parseInt(transparency) * 0.01 : 0;

  result = `rgba(${parseInt(result[1], 16)},${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${opacity})`;
  return result;
};

export const formStyles = (formDesign) => {
  const {
    design: {
      form_background,
      form_background_type,
      form_background_transparency,
      form_background_image,
      form_background_image_repeat,
      form_background_image_size,
      form_background_image_fixed,
      form_gradient_start_color: colorStart,
      form_gradient_end_color: colorEnd,
      form_gradient_type: gradientType,
      form_gradient_shape: shape,
      form_gradient_direction: direction,
    },
  } = formDesign;

  switch (form_background_type) {
    case 'fill':
      return {
        backgroundBlendMode: 'overlay',
        backgroundColor: form_background && formHexToRgbA(form_background, form_background_transparency),
      };

    case 'image':
      return {
        backgroundImage: form_background_image && `url('${form_background_image}')`,
        backgroundRepeat: form_background_image_repeat ? 'repeat' : 'no-repeat',
        backgroundSize: form_background_image_size && form_background_image_size,
        backgroundAttachment: form_background_image_fixed ? 'fixed' : 'scroll',
      };

    case 'gradient':
      return {
        backgroundBlendMode: 'overlay',
        backgroundImage: setGradient(colorStart, colorEnd, gradientType, shape, direction),
      };

    default:
      return null;
  }
};

export const isOverPendingLimit = (pending) => {
  const MaxPending = 3;
  const errMsg = 'You can only upload 3 images at a time. Please wait.';
  if (pending < MaxPending) {
    return false;
  }
  // Alert error message
  toast.error(errMsg);
  return true;
};

export const isImageValid = (files) => {
  const validImageTypes = new Set(['image/gif', 'image/jpeg', 'image/png']);

  for (let i = 0; i < files.length; i += 1) {
    const image = files[i];
    const MAXSIZE = 10 ** 7;
    const typeValidity = validImageTypes.has(image.type);
    const sizeValidity = image.size < MAXSIZE;

    if (!typeValidity) {
      const errMsg = 'This file type is not supported. Image must be in .png, jpeg or gif format';
      // Alert error message
      toast.error(errMsg);
      return false;
    }
    if (!sizeValidity) {
      const errMsg = 'Image is too large (max 10MB)';
      // Alert error message
      toast.error(errMsg);
      return false;
    }
  }
  return true;
};

export const localImageHandler = (files) => {
  const localImages = [];

  for (let i = 0; i < files.length; i += 1) {
    const image = files[i];
    const _URL = window.URL || window.webkitURL;
    const blobURL = _URL.createObjectURL(image);
    const created = new Date().toISOString();
    const randomId = Math.floor(Math.random() * 10 ** 7);
    const data = {
      id: randomId,
      created,
      name: image.name,
      url: blobURL,
      file: files[i],
      uploading: true,
    };
    localImages.push(data);
  }

  return localImages;
};

export const validateLink = (link) => {
  const linkPattern =
    '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?';
  if (!link.match(linkPattern)) {
    return false;
  }
  return true;
};

export const visiblePages = (pages, hiddenFields) => {
  const visible = [];
  for (let iota = 0; iota < pages.length; iota += 1) {
    if (!hiddenFields[pages[iota].internal_id]) {
      visible.push(pages[iota]);
    }
  }
  return visible;
};

export const isHiddenField = (page, hiddenFields) => {
  if (hiddenFields === undefined) return;
  if (page.internal_id) return hiddenFields[page.internal_id];
  return false;
};

export const validateBrokenImage = async (link) => {
  const promise = new Promise((resolve) => {
    const virtualImage = new Image();
    virtualImage.src = link;
    virtualImage.onload = () => resolve(true);
    virtualImage.onerror = () => resolve(false);
  });

  return promise;
};

export const generateThemesNameList = (themeTemplates) => {
  const themesNamesList = themeTemplates.map((theme) => ({
    key: theme.name,
    value: theme.name,
    label: theme.name,
  }));
  return themesNamesList;
};

export function generateActiveTheme(designObj, themeTemplates) {
  if (!designObj) {
    return blankDesignTheme;
  }
  const { themeName } = designObj;
  const theme = themeTemplates.find((themeTemplate) => themeTemplate.name === themeName);
  return theme || blankDesignTheme;
}

export function getPDFForm() {
  try {
    const serializedState = localStorage.getItem('pdf');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}

export const getActivePage = (location, path) => {
  if (location.pathname.includes(path)) {
    return 'active_nav';
  }
};

export function selectedEntryIds(entryIdObj) {
  let allIds = Object.keys(entryIdObj).filter((entryId) => entryIdObj[entryId] === true);
  allIds = allIds.map((singeId) => {
    return parseInt(singeId);
  });
  return allIds;
}

export function isEntryIdEmpty(entryIdObj) {
  const ids = Object.keys(entryIdObj);
  for (let i = 0; i < ids.length; i += 1) {
    const entryId = ids[i];
    if (entryIdObj[entryId]) {
      return false;
    }
  }
  return true;
}

export function emptyOrNot(type = '', idx, rating = 0) {
  if (idx + 1 > rating) {
    return 'empty';
  }
  return type === 'star_rating' ? 'yellow' : 'red';
}

const fieldWithoutQuickEdit = {
  media_image: true,
  description: true,
  media_header: true,
  embed_field: true,
};

export function noQuickEditField(type) {
  if (!fieldWithoutQuickEdit[type]) return false;
  return true;
}

export const genPageName = (pagName, idx) => {
  if (pagName === 'default') {
    return `Page ${idx + 1}`;
  }
  if (pagName !== undefined) {
    return pagName;
  }
  return '';
};

export function validateMatchingBrackets(value) {
  const stack = [];
  const map = { '(': ')' };
  for (let i = 0; i < value.length; i += 1) {
    if (value[i] === '(' || value[i] === ')') {
      if (value[i] === '(') {
        stack.push(value[i]);
      } else {
        const last = stack.pop();
        if (value[i] !== map[last]) {
          return false;
        }
      }
    }
  }
  if (stack.length !== 0) {
    return false;
  }

  return true;
}

export function newIdentifier(identifiers) {
  let candidateId = Date.now();
  if (candidateId.toString() in identifiers) {
    candidateId += 1;
  }
  candidateId = candidateId.toString();
  return candidateId;
}

export const isValueForTable = (str) => /_/.test(str);

export const getInternalId = (ctrl) => {
  let { internal_id } = ctrl;
  if (typeof ctrl === 'string') {
    internal_id = ctrl;
  }
  return internal_id;
};

export const truncText = (str, truncPoint = 40) => {
  if (str && str.length > truncPoint) {
    return `${str.substring(0, truncPoint)}...`;
  }
  return str;
};

export const getTitleForTruncText = (str, truncPoint = 40) => {
  if (str && str.length <= truncPoint) {
    return '';
  }
  return str;
};

export const getResultField = (result) => {
  if (isValueForTable(result)) {
    return result.split('_')[0];
  }
  return result;
};

export const getTableResultFieldColumn = (result, ctrlIndex) => {
  const [tableId, tableResultColIndex] = result.split('_');
  const columnHeader = ctrlIndex[tableId]?.props.column_headers[tableResultColIndex];
  return columnHeader;
};

export const pageIsLogicAction = (rules, pageId) => {
  for (const rule of rules) {
    if (rule.triggered_field_id === pageId) return true;
    if (rule.option) return rule.actions.some((action) => action.id === pageId);
  }
  return false;
};

export const isCalcOperandField = (calculations, ctrl) => {
  if (!ctrl || calculations.length === 0) return false;

  const ctrlId = getInternalId(ctrl);
  const internalRowIds = ctrl.props?.controls || [];

  return calculations.some((calculation) => {
    const operandsArrayAsString = calculation.operands.join(' ');
    const fieldInRowIsCalcOperand = internalRowIds.some((id) => calculation.operands.includes(id));

    return (
      calculation.operands.includes(ctrlId) ||
      (/_/.test(operandsArrayAsString) && operandsArrayAsString.includes(ctrlId)) ||
      fieldInRowIsCalcOperand
    );
  });
};

export const checkLogic = (rules, ctrl) => {
  const rulesAttached = [];
  const ctrlId = getInternalId(ctrl);
  const internalRowIds = ctrl.props?.controls || [];

  rules.forEach((rule, index) => {
    const {
      triggering_field_id: triggeringFieldId,
      triggered_field_id: triggeredFieldId,
      option,
      triggers,
      actions,
    } = rule;

    const rulePresent = triggeringFieldId === ctrlId || triggeredFieldId === ctrlId;
    if (rulePresent) {
      rulesAttached.push(index);
      return rulesAttached;
    }

    if (option) {
      const hasTrigger = triggers.some((trigger) => trigger.id === ctrlId || internalRowIds.includes(trigger.id));
      const hasAction = actions.some((action) => action.id === ctrlId || internalRowIds.includes(action.id));

      if (hasTrigger || hasAction) {
        rulesAttached.push(index);
      }
    }
  });

  return rulesAttached;
};

export const checkCalculation = (calculations, ctrl) => {
  if (!ctrl || calculations.length === 0) return [];

  const calculationsAttached = [];
  const ctrlId = getInternalId(ctrl);
  const internalRowIds = ctrl.props?.controls || [];

  calculations.forEach((calculation, index) => {
    const operandsArrayAsString = calculation.operands.join(' ');
    const fieldInRowHasCalc = internalRowIds.some(
      (id) => calculation.operands.includes(id) || calculation.result.includes(id)
    );

    const isCalculationAttached =
      calculation.operands.includes(ctrlId) ||
      (/_/.test(operandsArrayAsString) && operandsArrayAsString.includes(ctrlId)) ||
      calculation.result === ctrlId ||
      calculation.result.includes(ctrlId) ||
      fieldInRowHasCalc;

    if (isCalculationAttached) {
      calculationsAttached.push(index);
    }
  });

  return calculationsAttached;
};

export const newForm = {
  name: '',
  pages: [{}],
  pageIds: [[]],
  pagesName: ['default'],
  identifiers: {},
  pagesIdentifiers: [],
  rules: [],
  calculations: [],
};

const internalId = newIdentifier(Object.keys(newForm.identifiers));
newForm.pagesIdentifiers.push(internalId);
newForm.identifiers[internalId] = true;

/**
 * Checks whether an array of strings contains any empty or whitespace-only values.
 *
 * @param {string[]} strings - The array of strings to inspect.
 * @returns {boolean} `true` if at least one string is empty or consists only of whitespace; otherwise `false`.
 */
export const hasEmptyString = (strings) => strings.some(str => !str || /^\s*$/.test(str));

/**
 * Checks if an array contains any duplicate non-empty, trimmed string values.
 *
 * @param {string[]} array - The array of strings to inspect.
 * @param {object} [options]
 * @param {boolean} [options.ignoreEmpty=false] - Whether to ignore empty or whitespace-only strings.
 * @returns {boolean} `true` if duplicates exist; otherwise `false`.
 */
export const hasDuplicateString = (array, { ignoreEmpty = false } = {}) => {
  const seen = new Set();

  for (let str of array) {
    str = str.trim();
    if (ignoreEmpty && !str) continue;
    if (seen.has(str)) return true;
    seen.add(str);
  }

  return false;
};

/**
 * Checks whether an array of strings contains any literal
 * "undefined" or "null" values (case-insensitive).
 *
 * @param {string[]} strings - The array of strings to inspect.
 * @returns {boolean} `true` if at least one string is "undefined" or "null"; otherwise `false`.
 */
export const hasLiteralNullOrUndefined = (strings) =>
  strings.some(str => {
    const lower = String(str).toLowerCase().trim();
    return lower === 'undefined' || lower === 'null';
  });

export function retrieveFromCookie(form_id) {
  return document.cookie.indexOf(`${form_id}-submitted=1`) >= 0 || window.HAS_SUBMITTED;
}

export const sleep = async (n) => new Promise((resolve) => setTimeout(resolve, n * 800));

export function checkUnallowedPremiumFields(form) {
  const { pages, rules } = form.definition;
  const unallowedPremiumFields = [];
  if (rules.length >= 1 && !win.PLAN.allowed_features.RULES) {
    unallowedPremiumFields.push('Form Logic');
  }
  for (const { controls } of pages) {
    for (const control of controls) {
      const ctrlType = control.type;
      const isPremiumfields = win.PLAN.allowed_fields[ctrlType];
      if (!isPremiumfields) {
        unallowedPremiumFields.push(ctrlType);
      }
    }
  }
  return unallowedPremiumFields;
}

export const getField = (controls, id) => {
  const field = controls.find((ctr) => ctr.internal_id === id);
  return field;
};

export const getEmptyTableFields = (row, col) => {
  return [...Array(row).keys()].map(() => [...Array(col).keys()].map(() => ''));
};

export const getEditorCharDetails = (str = '') => {
  const regMatch = str.match(/{[^}]*}}|\S+/g);
  const stringLength = str.trim().length;
  const arrayOfLines = str.split(/\r\n|\r|\n/);
  const charCount = arrayOfLines ? arrayOfLines.at(-1).length : 0;
  const wordCount = stringLength === 0 ? 0 : regMatch.length;
  const lineCount = arrayOfLines ? arrayOfLines.length : 0;
  return { wordCount, charCount, lineCount };
};

// Prevent numeric key input (0–9 and numpad 0–9)
export const blockNumericKeyInput = (e) => {
  const key = e.keyCode || e.which;
  const isStandardNumber = key >= 48 && key <= 57; // 0–9
  const isNumpadNumber = key >= 96 && key <= 105; // Numpad 0–9

  if (isStandardNumber || isNumpadNumber) {
    e.preventDefault();
  }
};

// Prevent pasting numeric-only values
export const blockNumericPaste = (e) => {
  const pastedText = e.clipboardData.getData('text');
  if (!isNaN(pastedText) && pastedText.trim() !== '') {
    e.preventDefault();
  }
};

export const convertDayStarterToYearStarter = (dateString, separator) => {
  const [datePart, timePart, timeUnit] = dateString.split(' ');
  const [day, month, year] = datePart?.split(separator);
  let formattedDate = `${year}/${month}/${day}`;

  if (timePart) {
    formattedDate += ` ${timePart}`;
    if (timeUnit) {
      formattedDate += ` ${timeUnit}`;
    }
  }

  return formattedDate;
};

export const parseDateStringForFormat = (date, format, separator) => {
  return format === 'DD/MM/YYYY' ? new Date(convertDayStarterToYearStarter(date, separator)) : new Date(date);
};

export const parseDateStringWithOrdinalIndicator = (dateString) => {
  // For dates strings in valid month and ordinal formats
  // e.g Jan 25th || 25th Jan || 20th January || January 20th || 20th, January 2024 || 20th January, 2024
  // Remove ordinal indicator ("th") and the comma
  const formattedDateString = dateString.replace(/(st|nd|rd|th)|,/g, '');

  // Create a date object using the formatted string
  const date = new Date(formattedDateString);
  return date;
};

export const getFormattedDate = (date, format, separator) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  if (format === `YYYY/MM/DD`) return `${year}${separator}${month}${separator}${day}`;
  else if (format === `MM/DD/YYYY`) return `${month}${separator}${day}${separator}${year}`;
  else if (format === `DD/MM/YYYY`) return `${day}${separator}${month}${separator}${year}`;
};

export const getDatesInRange = (range, format, separator) => {
  if (!range || !range.includes('to')) return [];

  const [startDate, endDate] = range.split(' to ');
  const start = parseDateStringForFormat(startDate, format, separator);
  const end = parseDateStringForFormat(endDate, format, separator);

  const dateList = [];
  let currentDate = new Date(start);

  while (currentDate <= end) {
    dateList.push(getFormattedDate(currentDate, format, separator));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dateList;
};

export const isDateString = (str, separator) => {
  const date = new Date(str);
  return str.includes(separator) && !isNaN(date) && !isNaN(Date.parse(str));
};

export const isTimeString = (str) => {
  // Regular expression for 24-hour format (HH:MM or HH:MM:SS)
  const twentyFourHourPattern = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;

  // Regular expression for 12-hour format (hh:MM AM/PM or hh:MM:SS AM/PM)
  const twelveHourPattern = /^(0[1-9]|1[0-2]):[0-5][0-9](:[0-5][0-9])? [APap][mM]$/;

  // Test if the string matches either format
  return twentyFourHourPattern.test(str) || twelveHourPattern.test(str);
};

export const compareTimes = (time1, time2) => {
  const timePattern = /(\d{1,2}):(\d{2}) ([APap][Mm])/;

  const [, hour1, minute1, period1] = time1.match(timePattern);
  const [, hour2, minute2, period2] = time2.match(timePattern);

  const hour1Int = parseInt(hour1);
  const hour2Int = parseInt(hour2);
  const minute1Int = parseInt(minute1);
  const minute2Int = parseInt(minute2);

  if (period1.toLowerCase() === 'am' && period2.toLowerCase() === 'pm') {
    return -1; // time1 is earlier
  } else if (period1.toLowerCase() === 'pm' && period2.toLowerCase() === 'am') {
    return 1; // time2 is earlier
  } else {
    if (hour1Int < hour2Int) {
      return -1; // time1 is earlier
    } else if (hour1Int > hour2Int) {
      return 1; // time2 is earlier
    } else {
      if (minute1Int < minute2Int) {
        return -1; // time1 is earlier
      } else if (minute1Int > minute2Int) {
        return 1; // time2 is earlier
      } else {
        return 0; // Both times are the same
      }
    }
  }
};

export const convertWithoutTimeZone = (date, reverse) => {
  if (reverse) {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  } else {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  }
};

export const simpleMDEOptions = {
  placeholder: 'Start typing your message',
  sideBySideFullscreen: false,
  maxHeight: '250px',
  autofocus: true,
  tabSize: 4,
  toolbar: [
    'bold',
    'italic',
    'heading',
    '|',
    'quote',
    'ordered-list',
    'unordered-list',
    '|',
    'link',
    'image',
    '|',
    'preview',
    'side-by-side',
    'fullscreen',
    '|',
    'undo',
    'redo',
    '|',
    'guide'
  ],
};

export const isString = (str) => typeof str === 'string' || str instanceof String;

export const stringifyDate = (date) => {
  const mm = date.getMonth() + 1;
  const dd = date.getDate();
  const yy = date.getFullYear();
  return `${dd}/${mm}/${yy}`;
};

export const isInvalidEditorMsg = (message, adminUnflagged) => {
  if (adminUnflagged) return false;
  const link =
    /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi;
  const invalidMatches = message?.match(link);
  return invalidMatches;
};

export const isJSON = (string) => {
  try {
    const json = JSON.parse(string);
    if (Object.prototype.toString.call(json).slice(8, -1) !== 'Object') {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
};

export const connectStripe = (live) => {
  const clientId = live ? win.PAYMENT_DETAILS.live_stripe_client_id : win.PAYMENT_DETAILS.test_stripe_client_id;
  const stripeState = live ? 'formplus_live_state' : 'formplus_test_state';
  const redirectUri = `${window.location.origin}/stripe_connect_auth_finish`;
  const oauthUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=read_write&state=${stripeState}`;
  window.open(
    oauthUrl,
    '_blank',
    `top=0,left=0,width=${window.screen.availWidth},height=${window.screen.availHeight},channelmode=0,directories=0,fullscreen=0,location=0,menubar=0,resizable=0,scrollbars=0,status=0`
  );
};

export const fadeInAnimation = `
  animation: fadeInAnimation ease 1.0s;
  @keyframes fadeInAnimation {
    0% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const industries = [
  'Accounting',
  'Aviation',
  'Agriculture',
  'Arts',
  'Beauty/Cosmetics',
  'Construction',
  'Consultancy',
  'Design',
  'E-Commerce',
  'Education',
  'Engineering',
  'Entertainment',
  'Event Services',
  'Fashion',
  'Finance',
  'FMCG',
  'Food and Beverages',
  'Government',
  'Health and Fitness',
  'Healthcare',
  'Hospitality',
  'Industrial Goods',
  'Information and Communication Technology',
  'Insurance',
  'Legal Services',
  'Leisure and Travel',
  'Maritime',
  'Marketing',
  'Manufacturing',
  'Medical Practice',
  'Military',
  'News and Media',
  'Non-Profit/Volunteering',
  'Oil & Gas/Energy/Solar/Greentech',
  'Pharmaceuticals',
  'Photography',
  'Political Organisation',
  'Professional Services',
  'Public Administration',
  'Public Relations/PR',
  'Real Estate/Housing',
  'Recruiting/Human Resources',
  'Religious Institutions',
  'Restaurant',
  'Retail',
  'Sports',
  'Software',
  'Startup',
  'Technology',
  'Telecommunications',
  'Transportation',
  'Venture Capital & Private Equity',
];

export const mergeControlProps = (props) => {
  const { options, weights, images } = props;
  const mergedPropsArray = [];
  let newObj;

  for (let i = 0; i < options.length; i += 1) {
    newObj = {
      option: options[i],
      ...(weights && { value: weights?.[i] ?? 1 }),
      ...(images && { image: images?.[i] || '' }),
    };
    mergedPropsArray.push(newObj);
  }

  return mergedPropsArray;
};

export const unmergeControlProps = (mergedPropsArray, props) => {
  if (mergedPropsArray?.length <= 0) {
    console.error('Cannot offload a blank list.');
    return { error: true, message: 'Cannot offload a blank list.' };
  }

  const options = [];
  const weights = [];
  const images = [];

  mergedPropsArray.forEach(({ option, value, image }) => {
    options.push(option);
    weights.push(Number(value) ?? 1);
    images.push(image || '');
  });

  return { options, ...(props.weights && { weights }), ...(props.images && { images }) };
};

export const reactPages = [
  {
    paths: ['/r/builder/template/:templateId/:formId', '/r/form/:formId/builder', '/r/builder'],
    isProtected: true,
    title: 'Builder',
    name: 'Builder'
  },
  {
    paths: ['/e/:formId/report/:reportId'],
    isProtected: false,
    title: 'Report',
    name: 'Report'
  },
  {
    paths: ['/r/form/:formId/responses'],
    title: 'Responses',
    name: 'Responses',
    isProtected: true
  },
  {
    paths: ['/r/form/:formId/analytics'],
    title: 'Analytics',
    name: 'Analytics',
    isProtected: true
  },
  {
    paths: ['/r/form/:formId/customise'],
    title: 'Customise',
    name: 'Customise',
    isProtected: true
  },
  {
    paths: ['/r/invite/:teamId/:memberId'],
    title: 'Team Invite',
    name: 'TeamInvite',
    isProtected: false
  },
  {
    paths: ['/r/form/:formId/settings'],
    title: 'Settings',
    name: 'Settings',
    isProtected: true
  },
  {
    paths: ['/r/form/:formId/share'],
    isProtected: true,
    title: 'Share',
    name: 'Share'
  },
  {
    paths: ['/e/features/:featureId', '/e/features'],
    isProtected: false,
    title: 'Features',
    name: 'Features'
  },
  {
    paths: ['/r/details'],
    isProtected: true,
    title: 'Details',
    name: 'Details'
  },
  {
    paths: ['/e/auth'],
    isProtected: false,
    title: 'Sign in',
    name: 'SignIn'
  },
  {
    paths: ['/e/auth/sign-up'],
    isProtected: false,
    title: 'Sign up',
    name: 'SignUp'
  },
  {
    paths: ['/e/auth/reset-password'],
    title: 'Reset Password',
    name: 'ResetPassword',
    isProtected: false
  },
  {
    paths: ['/e/auth/confirm-2fa/:token'],
    title: 'Confirm 2FA',
    isProtected: false,
    name: 'Confirm2FA'
  },
  {
    title: 'Account Manager',
    name: 'AccountManager',
    paths: ['/r/account'],
    isProtected: true
  },
  {
    paths: ['/r/teams', '/r/teams/:teamId'],
    isProtected: true,
    title: 'Teams',
    name: 'Teams'
  },
  {
    paths: ['/r', '/r/', '/'],
    title: 'Dashboard',
    name: 'Dashboard',
    isProtected: true
  }
];

export const getActiveReactPage = () => {
  const pathname = window.location.pathname.replace(/\/+$/, '');
  
  for (const page of reactPages) {
    for (const path of page.paths) {
      const regex = new RegExp(`^${path.replace(/:([a-zA-Z_]+)/g, '[^/]+')}$`);
      if (!regex.test(pathname)) continue;
      return page;
    }
  }
  
  return {
    title: 'Page Not Found',
    name: 'PageNotFound',
    isProtected: false,
    paths: ['*']
  };
};

export const formatTimestampToSystemTimeZone = (timestamp) => {
  const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(timestamp);

  const datePart = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: systemTimeZone,
  }).format(date);

  const timePart = new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: systemTimeZone,
  }).format(date);

  return `${datePart}, ${timePart}`;
};

/**
 * Checks if a response object represents an error state.
 *
 * Handles both native `fetch` responses ({ ok, status }) and
 * custom API responses (e.g., { status: "OK", error }).
 *
 * @param {object} response - The response object to validate.
 * @returns {boolean} True if the response is invalid or contains an error; otherwise false.
 */
export function isInvalidResponse(response) {
  if (!response) return true;

  const { error, status, ok } = response;

  // Native fetch style: has `ok` boolean
  if (typeof ok === 'boolean') {
    return !ok || Boolean(error);
  }

  // Custom API style: uses status string (e.g., "OK", "ERROR")
  if (typeof status === 'string') {
    return status.toUpperCase() !== 'OK' || Boolean(error);
  }

  // Custom API style: numeric status code (e.g., 200, 404)
  if (typeof status === 'number') {
    return status >= 400 || Boolean(error);
  }

  return Boolean(error);
}

/**
 * Handle reducer API errors consistently
 * @param {object} params
 * @param {string} params.action - Short description of what failed (e.g. "fetch form")
 * @param {string} params.url - The request URL
 * @param {object} [params.response] - Response object (if available)
 * @param {Error} [params.error] - Error object (if thrown)
 * @param {function} params.rejectWithValue - Redux rejectWithValue function
 * @param {object} [params.messages] - Custom override messages
 * @param {string} [params.messages.notFound] - Message for 404
 * @param {string} [params.messages.failed] - Generic failure message
 * @param {string} [params.messages.unexpected] - Message for unexpected errors
 */
export function handleReducerApiError({ rejectWithValue, messages = {}, response, location, action, error, url }) {
  const RETRY_OR_CONTACT_SUPPORT = 'Please try again later or send an email to support@formpl.us if this persists';
  const NOT_FOUND = 'Requested resource could not be found';
  const CHECK_CONNECTION = 'Please check your connection';

  let loggableMessage;

  if (isInvalidResponse(response)) {
    loggableMessage = `${location}: Failed to ${action} | Status: ${response?.status || 'Unknown'} | Error: ${
      response?.error || response?.statusText || 'No error message provided'
    } | URL: ${url}`;
    const uiErrorMessage =
      Number(response?.status) === 404
        ? messages.notFound || NOT_FOUND
        : messages.failed || `Unable to ${action}. ${RETRY_OR_CONTACT_SUPPORT}.`;

    logErrorToCloudReporting(loggableMessage);
    toast.error(uiErrorMessage);

    return rejectWithValue({
      statusText: response?.statusText,
      status: response?.status,
      error: response?.error,
      uiErrorMessage,
    });
  }

  // Unexpected error
  loggableMessage = `${location}: Unexpected error while trying to ${action} | Error: ${
    error?.message || 'Unknown error'
  } | URL: ${url}`;
  const uiErrorMessage = messages.unexpected || `Unable to ${action}. ${CHECK_CONNECTION}.`;

  logErrorToCloudReporting(loggableMessage);
  toast.error(uiErrorMessage);

  return rejectWithValue({
    error: error?.message,
    uiErrorMessage,
  });
}

/**
 * Factory function to create standardized async thunks for API calls.
 *
 * This abstracts away the boilerplate for API requests, error handling,
 * and optional response transformations, while ensuring consistent
 * error logging and messages across reducers.
 *
 * @function createApiThunk
 *
 * @param {Object} options - Configuration for the thunk.
 * @param {string} options.typePrefix - The unique prefix for the thunk type (used by Redux Toolkit).
 * @param {string} options.action - Human-readable description of the action being performed (used in logs).
 * @param {string|function(Object): string} options.url - The API endpoint or a function that returns the endpoint from `args`.
 * @param {function(Object, string): Promise<any>} [options.fetcher] - Optional custom fetcher. Defaults to `fplsFetch`.
 * @param {function(any, Object): any} [options.transformer] - Optional function to transform the response before returning it.
 * @param {Object} [options.messages] - Optional custom error messages.
 * @param {string} [options.messages.notFound] - Message for 404 errors.
 * @param {string} [options.messages.failed] - Message for generic request failures.
 * @param {string} [options.messages.unexpected] - Message for unexpected errors.
 * @param {string} options.location - Logical location or module name where the API call is triggered (used in error logs).
 *
 * @returns {AsyncThunk} A Redux Toolkit `createAsyncThunk` for handling the API request.
 *
 * @example
 * export const fetchForm = createApiThunk({
 *   transformer: (response, { formId }) => updateFormInventoryProducts(response, formId),
 *   messages: { notFound: 'Requested form could not be found.' },
 *   url: ({ formId }) => `/api/v2/user/form/${formId}`,
 *   fetcher: (_, url) => fplsFetch({ url }),
 *   typePrefix: 'customise/fetchForm',
 *   location: 'CUSTOMISE REDUCER'
 *   action: 'fetch form',
 * });
 */
export function createApiThunk({ transformer, typePrefix, messages, location, fetcher, action, url }) {
  return createAsyncThunk(typePrefix, async (args, { rejectWithValue }) => {
    const baseUrl = typeof url === 'function' ? url(args) : url;

    try {
      const response = fetcher ? await fetcher(args, baseUrl) : await fplsFetch({ url: baseUrl });

      if (isInvalidResponse(response)) {
        return handleReducerApiError({
          rejectWithValue,
          url: baseUrl,
          response,
          messages,
          location,
          action,
        });
      }

      return transformer ? await transformer(response, args) : response;
    } catch (error) {
      return handleReducerApiError({
        rejectWithValue,
        url: baseUrl,
        messages,
        location,
        action,
        error,
      });
    }
  });
}

export default {
  getLoadingMessage,
  fplsFetch,
  list2Dict,
  rolesList,
  capitalize,
  capitalizr,
  emailTestPatterUnicode,
  getVersionRecords,
  getAvailableFields,
  hasDuplicates,
  preloadComponent,
  shortenDate,
  enabledNotes,
  readableDate,
  getNumbers,
  htmlToPlainText,
  setGradient,
  isOverPendingLimit,
  isImageValid,
  localImageHandler,
  validateLink,
  validateBrokenImage,
  apiCommon,
  generateThemesNameList,
  generateActiveTheme,
  applyTheme,
  insert,
  replaceAt,
  getPDFForm,
  getActivePage,
  selectedEntryIds,
  isEntryIdEmpty,
  newIdentifier,
  sleep,
  genPageName,
  isString,
  getField,
  getEmptyTableFields,
  industries,
};
